<h2>Toggle Modal</h2>
<app-button (onClick)="isModalVisible = true;" text="Toggle Modal"></app-button>
<app-modal #modal [(visible)]="isModalVisible" header="Title Here" (onCancel)="this.modal.hide()">
  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras gravida massa leo, ultricies laoreet nisl rutrum et.
  Vivamus ut massa commodo, pellentesque justo ut, mollis nisi. Aenean sit amet felis interdum, rutrum dolor et,
  imperdiet diam. Praesent laoreet lectus sit amet est fringilla egestas. Cras ex sapien, viverra non auctor id, commodo
  id metus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Duis porttitor
  malesuada elit eu convallis. Vestibulum ultrices, ipsum in tempus pretium, nibh ex condimentum est, nec hendrerit
  lectus ipsum at mauris. Ut eu vulputate elit. Fusce commodo consectetur dignissim. Etiam erat urna, imperdiet ut
  placerat at, iaculis nec velit. Proin justo diam, placerat nec vestibulum id, varius maximus libero. Vivamus tristique
  quam massa, ut aliquam libero porta vitae.
  <footer>
    <app-button (onClick)="this.modal.hide()" text="Action"></app-button>
  </footer>
</app-modal>


<h2>Collapsible Modal</h2>
<app-button (onClick)="isCollapsibleModalVisible = true;" text="Toggle Collapsible Modal"></app-button>
<app-collapsible-modal [(visible)]="isCollapsibleModalVisible" header="Title Here" (onCancel)="this.modal.hide()">
  Press the icon to the top right to collapse the modal. Also, user still has access to the background page. 
  <footer>
    <app-button (onClick)="this.modal.hide()" text="Action"></app-button>
  </footer>
</app-collapsible-modal>


<h2>Confirmation Modal</h2>
<app-button (onClick)="isConfirmationVisible = true;" text="Toggle Confirmation Modal"></app-button>
<app-confirmation-modal
  [(visible)]="isConfirmationVisible"
  header="Title Here"
  rejectText="Text for No"
  (onCancel)="noAction()"
  (onYes)="yesAction()">
  Are you sure you want to answer this question?
</app-confirmation-modal>

<h2>Result Modal</h2>
<app-button (onClick)="isResultVisible = true;" text="Toggle Result Modal"></app-button>
<app-result-modal
  [(visible)]="isResultVisible"
  header="Title Here"
  rejectText="Text for No">
  Are you sure you want to answer this question?
</app-result-modal>


<h2>Popover Modal</h2>
<app-button (onClick)="testPopover.toggle($event)" text="Toggle Popover"></app-button>
<app-popover #testPopover>
  I'm testing this popover.
</app-popover>

<h2>Accordion</h2>
<app-accordion-panel>
  <app-accordion-tab header="Tab 1" [isSelected]="true">
    Content for tab 1. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
  </app-accordion-tab>
  <app-accordion-tab header="Tab 2" [isSelected]="false">
    Content for tab 2. Cras gravida massa leo, ultricies laoreet nisl rutrum et.
  </app-accordion-tab>
  <app-accordion-tab header="Tab 3" [isSelected]="false">
    Content for tab 3. Vivamus ut massa commodo, pellentesque justo ut, mollis nisi.
  </app-accordion-tab>
</app-accordion-panel>

<h2>Accordion Card (hover shadow)</h2>
<p-accordion class="app-accordion">
  <p-accordionTab header="Card 1" class="app-accordion_card" [selected]="true">
    Content for card 1. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
  </p-accordionTab>
  <p-accordionTab header="Card 2" class="app-accordion_card" [selected]="false">
    Content for card 2. Cras gravida massa leo, ultricies laoreet nisl rutrum et.
  </p-accordionTab>
</p-accordion>

<h2>Accordion Card (p-header width)</h2>
<p-accordion class="app-accordion">
  <p-accordionTab class="app-accordion_card" [selected]="true">
    <p-header>
      <div class="fake-card-header">
        <span>Fake card header title</span>
        <span>Right-aligned content</span>
      </div>
    </p-header>
    Content for the p-header width test card.
  </p-accordionTab>
</p-accordion>